import React from 'react';

import { useTypeFilterService } from 'features/tasks-list-feature';

import FilterWidgetLayout from '../FilterWidgetLayout';
import { TeamPermission } from 'nekst-api';
import { useAuthorizationChecker } from 'authorization-scope';
import useFeatureToggleService from 'feature-toggle';

function KeyDateWidget() {
  const typeFilterService = useTypeFilterService();

  const currentValue = typeFilterService.getFilterValue();

  if (currentValue && currentValue.showKeyDatesOnly) {
    const resetKeyDate = () => {
      typeFilterService.setFilterValue({
        ...currentValue,
        showKeyDatesOnly: false,
      });
    };

    return (
      <FilterWidgetLayout
        name=""
        text="Key Dates Only"
        onClick={resetKeyDate}
      />
    );
  } else {
    return null;
  }
}

function RoadmapWidget() {
  const typeFilterService = useTypeFilterService();

  const currentValue = typeFilterService.getFilterValue();

  if (currentValue && currentValue.showRoadmapOnly) {
    const resetRoadmap = () => {
      typeFilterService.setFilterValue({
        ...currentValue,
        showRoadmapOnly: false,
      });
    };

    return (
      <FilterWidgetLayout
        name=""
        text="Roadmap Tasks Only"
        onClick={resetRoadmap}
      />
    );
  } else {
    return null;
  }
}

function TaskTypeWidget() {
  const typeFilterService = useTypeFilterService();

  const { isGranted } = useAuthorizationChecker();

  const currentValue = typeFilterService.getFilterValue();

  const featureToggleService = useFeatureToggleService();

  if (currentValue && (
    !currentValue.showEmailTasks
    || !currentValue.showStandardTasks
    || !currentValue.showSmsTasks
    || !currentValue.showEventTasks
  )) {
    const resetTypes = () => {
      typeFilterService.setFilterValue({
        ...currentValue,
        showStandardTasks: true,
        showEmailTasks: true,
        showSmsTasks: true,
      });
    };

    const types = [];

    if (currentValue.showStandardTasks) {
      types.push('Standard Tasks');
    }

    if (currentValue.showEmailTasks) {
      types.push('Email Tasks');
    }

    if (isGranted(TeamPermission.USE_SMS_TASKS_FEATURE) && currentValue.showSmsTasks) {
      types.push('SMS Tasks');
    }

    if (featureToggleService.isEventTasksEnabled() && currentValue.showEventTasks) {
      types.push('Appointment Tasks');
    }

    return (
      <FilterWidgetLayout
        name="Types"
        text={types.join(', ')}
        onClick={resetTypes}
      />
    );
  } else {
    return null;
  }
}

export default function TypeWidget() {
  return (
    <>
      <KeyDateWidget />
      <RoadmapWidget />
      <TaskTypeWidget />
    </>
  );
}
